import { useRef } from 'react'
import PropTypes from 'prop-types'
import {
  CloseButton,
  Inline,
  Text
} from '@leroy-merlin-br/backyard-react-ui'

import { AlertMessage } from 'reactShared/components/AlertMessage'

import { useBodyScrollLock } from 'reactUtils/hooks/use-body-scroll-lock'

import { getSortedModalities } from 'catalog/utils/sort-shipment-modalities'

import { ShipmentModality } from '../ShipmentModality'
import * as S from './styled'

const ModalContent = ({ onClose, regionName, shipments, skus }) => {
  const elementRef = useRef()

  useBodyScrollLock(elementRef)

  const canShowPickupInStore = sku => {
    return sku.id === '' && sku.purchaseButtons?.pickupInStore
  }

  const renderShipmentOption = sku => {
    const skuShipments = shipments.find(seller => {
      return seller.skuId === sku.id || (!seller.skuId && !sku.id)
    })
    const skuModalities = skuShipments && getSortedModalities(skuShipments)

    return (
      <S.Seller key={sku.id} data-testid="seller-wrapper">
        <S.SellerName>
          {sku.shop.name}
        </S.SellerName>

        {!skuShipments && !canShowPickupInStore(sku) && (
          <AlertMessage type="critical">
            <Text as="strong" size="kilo" bold noMargin>
              Ops!{' '}
            </Text>
            Tivemos um problema ao tentar apresentar o frete,{' '}
            <Text as="strong" size="kilo" bold noMargin>
              mas você poderá conferi-lo em seu carrinho
            </Text>
            .
          </AlertMessage>
        )}

        {canShowPickupInStore(sku) && (
          <ShipmentModality modality="pickupInStore" cost={0} />
        )}

        {skuShipments &&
          skuModalities.map(modality => (
            <ShipmentModality
              key={modality}
              modality={modality}
              {...skuShipments.modalities[modality]}
            />
          ))}
      </S.Seller>
    )
  }

  return (
    <S.Modal>
      <S.ModalHeader>
        <Inline spacing="bit" justify="between" noWrap>
          <div>
            <S.Title>
              Formas de frete para <S.TitleRegion>{regionName}</S.TitleRegion>
            </S.Title>

            <S.Subtitle size="kilo" noMargin>
              Confira todas as opções de entrega disponíveis.
            </S.Subtitle>
          </div>
          <CloseButton onClick={onClose} />
        </Inline>
      </S.ModalHeader>

      <S.ModalBody ref={elementRef}>
        {skus.map(sku => renderShipmentOption(sku))}
      </S.ModalBody>
    </S.Modal>
  )
}

ModalContent.propTypes = {
  onClose: PropTypes.func.isRequired,
  regionName: PropTypes.string.isRequired,
  shipments: PropTypes.arrayOf(
    PropTypes.shape({
      skuId: PropTypes.string,
      modalities: PropTypes.objectOf(
        PropTypes.shape({
          cost: PropTypes.number.isRequired,
          quotePrice: PropTypes.number.isRequired,
          deadline: PropTypes.number.isRequired
        })
      )
    })
  ).isRequired,
  skus: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      shop: PropTypes.shape({
        name: PropTypes.string
      })
    })
  ).isRequired
}

export default ModalContent
